import { render, staticRenderFns, recyclableRender, components } from "./u-image.vue?vue&type=template&id=6dd0d12f&scoped=true&"
var renderjs
import script from "./u-image.vue?vue&type=script&lang=js&"
export * from "./u-image.vue?vue&type=script&lang=js&"
import style0 from "./u-image.vue?vue&type=style&index=0&id=6dd0d12f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0d12f",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-image/u-image.vue"
export default component.exports